import React, { useState, useEffect, useRef, Fragment } from "react";
import { Link, useNavigate } from "react-router-dom";
import { TrbIcon } from "../resources/svg";

const Header = () => {
    const [activeLink, setActiveLink] = useState("home");
    const targetButtonRef = useRef(null);
    let calendlyScript = null;
    const navigate = useNavigate();
    
    // const calendlyLink = "https://calendly.com/trbai-info";
    // const handleCalendlyPopup = () => {
    //     if (typeof window.Calendly !== "undefined") {
    //         window.Calendly.initPopupWidget({ url: calendlyLink });
    //     } else {
    //         console.error("Calendly script is not loaded.");
    //         alert("Calendly is not ready yet. Please try again in a moment.");
    //     }
    // };

    const handleSetActiveLink = (link) => {
        setActiveLink(link);
        if (window.location.pathname !== "/") {
            navigate(`/#${link}`);
        }
    };

    // const goToHomePage = () => {
    //     setActiveLink("home");
    //     if (targetButtonRef.current) {
    //         targetButtonRef.current.click();
    //     }
    // };

    const toggleMobileNav = () => {
        const mobileNavToggleBtn = document.querySelector(".mobile-nav-toggle");
        document.body.classList.toggle("mobile-nav-active");
        mobileNavToggleBtn.classList.toggle("bi-list");
        mobileNavToggleBtn.classList.toggle("bi-x");
    };

    const closeMobileNav = () => {
        const mobileNavToggleBtn = document.querySelector(".mobile-nav-toggle");
        document.body.classList.remove("mobile-nav-active");
        mobileNavToggleBtn.classList.add("bi-list");
        mobileNavToggleBtn.classList.remove("bi-x");
    };

    useEffect(() => {
        // Set active link from hash if on homepage
        if (window.location.hash && window.location.pathname === "/") {
            const hashCode = window.location.hash.split("#")[1];
            setActiveLink(hashCode);
        }

        // Load Calendly script dynamically
        calendlyScript = document.createElement("script");
        calendlyScript.src = "https://assets.calendly.com/assets/external/widget.js";
        calendlyScript.async = true;
        document.body.appendChild(calendlyScript);

        return () => {
            // Cleanup script on unmount
            if (calendlyScript) {
                document.body.removeChild(calendlyScript);
            }
        };
    }, []);

    return (
        <Fragment>
            <header
                id="header"
                className="header d-flex align-items-center sticky-top"
            >
                <div className="container-fluid container-xl position-relative d-flex align-items-center">
                    {/* Logo */}
                    <Link to="/" className="logo d-flex align-items-center me-auto">
                        <TrbIcon />
                    </Link>

                    {/* Navigation Menu */}
                    <nav id="navmenu" className="navmenu">
                        <ul>
                            <li
                                onClick={() => {
                                    handleSetActiveLink("home");
                                    closeMobileNav();
                                }}
                            >
                                <a
                                    href="#home"
                                    className={activeLink === "home" ? "active" : ""}
                                >
                                    Home
                                </a>
                            </li>
                            <li
                                onClick={() => {
                                    handleSetActiveLink("about");
                                    closeMobileNav();
                                }}
                            >
                                <a
                                    href="#about"
                                    className={activeLink === "about" ? "active" : ""}
                                >
                                    About
                                </a>
                            </li>
                            <li
                                onClick={() => {
                                    handleSetActiveLink("services");
                                    closeMobileNav();
                                }}
                            >
                                <a
                                    href="#services"
                                    className={activeLink === "services" ? "active" : ""}
                                >
                                    Services
                                </a>
                            </li>
                            <li className="dropdown"
                                onClick={() => {
                                    handleSetActiveLink("domains");
                                    closeMobileNav();
                                }}
                            >
                                <a href="#domains" className={activeLink === "domains" ? "active" : ""}>
                                    <span>Why Us</span>{" "}
                                    {/* <i className="bi bi-chevron-down toggle-dropdown"></i> */}
                                </a>
                                {/* <ul>
                    <li>
                      <a href="#">Internet of Things (IoT)</a>
                    </li>
                    <li>
                      <a href="#">Freight Management</a>
                    </li>
                    <li>
                      <a href="#">GIS Mapping</a>
                    </li>
                    <li>
                      <a href="#">Healthcare</a>
                    </li>
                  </ul> */}
                            </li>
                            <li
                                onClick={() => {
                                    handleSetActiveLink("contact");
                                    closeMobileNav();
                                }}
                            >
                                <a
                                    href="#contact"
                                    className={activeLink === "contact" ? "active" : ""}
                                >
                                    Contact
                                </a>
                            </li>
                        </ul>
                        <i
                            className="mobile-nav-toggle d-xl-none bi bi-list"
                            onClick={() => toggleMobileNav()}
                        ></i>
                    </nav>

                    {/* Calendly Button */}
                    {/* <button
                            className="btn-getstarted"
                            onClick={handleCalendlyPopup}
                        >
                            Book a Consultation
                        </button> */}
                </div>
            </header>
            {/* Calendly Badge Widget */}
            <link
                href="https://assets.calendly.com/assets/external/widget.css"
                rel="stylesheet"
            />
            <script
                src="https://assets.calendly.com/assets/external/widget.js"
                type="text/javascript"
                async
            ></script>
            <script
            // dangerouslySetInnerHTML={{
            //   __html: `
            //     window.onload = function() {
            //       Calendly.initBadgeWidget({
            //         url: 'https://calendly.com/trbai-info',
            //         text: 'Schedule time with me',
            //         color: '#0069ff',
            //         textColor: '#ffffff',
            //         branding: true
            //       });
            //     };
            //   `,
            // }}
            />
        </Fragment>
    );
}

export default Header;
